module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="gererrecapitulatifs_generalView">\r\n  <div class="gererrecapitulatifs-Header-Zone"></div>\r\n  <div class="gererrecapitulatifs-Layout-Zone"></div>\r\n</div>';
}
return __p;
};
